import React from 'react';
import { AppModalActionType } from '../actiontype/app-modal.actiontype';
import { LoginModalActionType } from '../actiontype/login-modal.actiontype';
import { ErrorModalActionType } from '../actiontype/error-modal.actiontype';
import { AppModalConstant } from '../constants/app-modal.constant';
import LoginModal from '../components/shared/modals/login-modal/login-modal.smart';
import SsoModal from '../components/shared/modals/sso-modal/sso-modal.smart';
import NoAccountFoundModal from '../components/shared/modals/no-account-found-modal/no-account-found-modal.smart';
import ErrorModal from '../components/shared/modals/error-modal/error-modal.smart';
import OtpModal from '../components/shared/modals/otp-modal/otp-modal.smart';
import { OtpModalActionType } from '../actiontype/otp-modal.actiontype';
import { SsoModalActionType } from '../actiontype/sso-modal.actiontype';
import { NoAccountFoundModalActionType } from '../actiontype/no-account-found-modal.actiontype';
import { OtpModalV2 } from '../components/shared/modals/otp-modal-v2/otp-modal-v2.smart'
import { RetryModal } from '../components/shared/modals/retry-modal/retry-modal.smart';

const initialState = {
    displayModal: false,
    activeModal: '',
    errorMsg: '',
    redirection: false,
    errorModalCallback: null
}

const Modals = {
    LOGIN_MODAL: {
        modalName: AppModalConstant.LOGIN_MOBILE_NUMBER_MODAL,
        modalType: <LoginModal />,
        modalTitle: AppModalConstant.LOGIN_MODAL_TITLE
    },
    OTP_MODAL: {
        modalName: AppModalConstant.ENTER_OTP_MODAL,
        modalType: <OtpModal />,
        modalTitle: AppModalConstant.LOGIN_MODAL_TITLE
    },
    SSO_MODAL: {
        modalName: AppModalConstant.SSO_MODAL,
        modalType: <SsoModal />,
        modalTitle: AppModalConstant.SSO_MODAL_TITLE
    },
    ERROR_MODAL: {
        modalName: AppModalConstant.GENERIC_ERROR_MODAL,
        modalType: <ErrorModal />,
        modalTitle: AppModalConstant.ERROR_MODAL_TITLE
    },
    NO_ACCOUNT_FOUND_MODAL: {
        modalName: AppModalConstant.NO_ACCOUNT_FOUND_MODAL,
        modalType: <NoAccountFoundModal />,
        modalTitle: ''
    },
    OTP_MODAL_V2: {
        modalName: AppModalConstant.OTP_MODAL_V2,
        modalType: <OtpModalV2 />,
        modalTitle: AppModalConstant.OTP_MODAL_V2_TITLE
    },
    RETRY_MODAL: {
        modalName: AppModalConstant.RETRY_MODAL,
        modalType: <RetryModal />,
        modalTitle: AppModalConstant.ERROR_MODAL_TITLE
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case AppModalActionType.CLOSE_MODAL:
            return {
                ...state,
                displayModal: false,
                activeModal: ''
            }
        case AppModalActionType.RESET_MODAL:
            return {
                ...state,
                displayModal: false,
                activeModal: '',
                errorMsg: ''
            }
        case AppModalActionType.OPEN_LOGIN_MODAL:
            return {
                ...state,
                displayModal: true,
                activeModal: Modals.LOGIN_MODAL,
                redirection: action.payload.redirection
            }
        case AppModalActionType.OPEN_OTP_MODAL:
            return {
                ...state,
                displayModal: true,
                activeModal: Modals.OTP_MODAL,
                redirection: action.payload.redirection
            }
        case AppModalActionType.OPEN_SSO_MODAL:
            return {
                ...state,
                displayModal: true,
                activeModal: Modals.SSO_MODAL,
                redirection: action.payload.redirection
            }
        case AppModalActionType.OPEN_NO_ACCOUNT_FOUND_MODAL:
            return {
                ...state,
                displayModal: true,
                activeModal: Modals.NO_ACCOUNT_FOUND_MODAL,
                redirection: action.payload.redirection,
                loginCallback: action.payload.loginCallback
            }
        case AppModalActionType.OPEN_ERROR_MODAL:
            return {
                ...state,
                displayModal: true,
                activeModal: Modals.ERROR_MODAL,
                errorMsg: action.payload.errorMsg,
                redirection: action.payload.redirection
            }
        case AppModalActionType.OPEN_OTP_MODAL_V2:
            return {
                ...state,
                displayModal: true,
                activeModal: Modals.OTP_MODAL_V2,
                redirection: action.payload.redirection
            }
        case AppModalActionType.OPEN_RETRY_MODAL:
            return {
                ...state,
                displayModal: true,
                activeModal: {...Modals.RETRY_MODAL, ...action.payload},
                redirection: action.payload.redirection
            }
        case AppModalActionType.SET_ERROR_MODAL_CALLBACK:
            return {
                ...state,
                errorModalCallback: action.payload
            }
        default:
            return state;
    }
}